<template>
  <div v-if="user.email" class="library-container m-16 rounded-6 relative">
    <div>
      <router-view />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();

store.dispatch('fetchBatches', { page: 1, search: '' });

const user = computed(() => store.state.user);
</script>
